var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSlider1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.998,
    height: 35,
    viewBox: "0 0 34.998 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_486",
    "data-name": "Group 486",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3737",
    "data-name": "Path 3737",
    d: "M-458.121,153.58a17.541,17.541,0,0,0,17.475-17.534,17.537,17.537,0,0,0-17.541-17.466,17.535,17.535,0,0,0-17.456,17.551A17.537,17.537,0,0,0-458.121,153.58Zm-2.583-17.445a3.01,3.01,0,0,1,.333.248q2.382,2.386,4.759,4.778a1.6,1.6,0,0,1,.09,2.32,1.592,1.592,0,0,1-2.322-.067q-3.045-3.041-6.086-6.086a1.6,1.6,0,0,1,0-2.459q3.051-3.06,6.112-6.112a1.591,1.591,0,0,1,2.294-.077,1.585,1.585,0,0,1-.053,2.321c-.71.712-1.426,1.42-2.137,2.131C-458.685,134.107-459.655,135.083-460.7,136.135Z",
    transform: "translate(475.644 -118.58)",
    fill: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3738",
    "data-name": "Path 3738",
    d: "M-278.692,255.936c1.049-1.053,2.019-2.029,2.992-3,.711-.712,1.426-1.419,2.137-2.131a1.585,1.585,0,0,0,.053-2.321,1.591,1.591,0,0,0-2.294.077q-3.06,3.052-6.112,6.112a1.6,1.6,0,0,0,0,2.459q3.04,3.046,6.086,6.086a1.592,1.592,0,0,0,2.322.067,1.6,1.6,0,0,0-.09-2.32q-2.377-2.391-4.759-4.778A3.01,3.01,0,0,0-278.692,255.936Z",
    transform: "translate(293.633 -238.381)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlider1);
export default __webpack_public_path__ + "static/media/slider1.acba0d5f4e2601758a1de82842e54b1e.svg";
export { ForwardRef as ReactComponent };